import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';
import {Provider} from "react-redux";
import store from "./DAL/store"


/**
 * entry point
 */
export const init = () => {
    const $root = document.getElementById('olp-creator-presets-app');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <App />
            </Provider>
        </React.StrictMode>,
        $root
    );
};

/**
 * entry point
 */
document.addEventListener('DOMContentLoaded', () => {
    init();
});